import styled from 'styled-components';

export const StyledBackofficeListReports = styled.div`
    margin-bottom: 1.5rem;

    .row  {
      .container-form {
        margin-left: 10px;
      
        label {
          display: block;
          font-size: 15px;
          margin-bottom: 5px;
        }  
        
        input {
          border: 1px solid #B7B7B7;
          height: 33px;
          padding: 0 15px;
          color: #2B2932;
          font-size: 15px;
        }
        
        select {
          border-radius: 12px;
          padding: 0 10px;
          color: #2B2932;
          
          .muted {
            color: #CCCCCC;
          }
        }
        
        button {
          display: inline-block;
          background-color: #FFFFFF;
          border-radius: 12px;
          border: 1px solid #CFCFCF;
          margin-right: 20px;
          color: #2B2932;
          padding: 3px 50px 3px 15px;
          outline: 0;
          
          &.active {
            background-color: #F1F1F1;  
          }
          
          &:hover {
            background-color: #F1F1F1;
          }
        }
      }
  }
`;
